import type { AssignableRole, PlatformRole } from "@ir/contracts";

/**
 * Única traducción de los roles de plataforma. Vivía duplicada en la barra
 * lateral y en la tabla de usuarios, y en ambas faltaba `client`, que caía en
 * el rótulo por omisión y aparecía como "Analista": el panel afirmaba de una
 * persona externa justo lo que la separa de la plantilla de IR ADVISER.
 *
 * El Record da exhaustividad —añadir un rol a PlatformRole rompe la
 * compilación aquí—; el Map da la búsqueda, porque lo que llega de la API es
 * un `string` cualquiera y `Record<PlatformRole, string>` mentiría al decir
 * que cualquier clave resuelve.
 */
const ETIQUETAS: Record<PlatformRole, string> = {
  ir_admin: "admin.roleAdmin",
  ir_publisher: "admin.rolePublisher",
  ir_analyst: "admin.roleAnalyst",
  client: "admin.roleClient",
};

const POR_CLAVE = new Map<string, string>(Object.entries(ETIQUETAS));

export function roleLabelKey(role: string): string {
  // Un rol desconocido se muestra tal cual (i18next devuelve la clave que no
  // encuentra) en vez de disfrazarse del rol más común: es un dato corrupto y
  // debe verse como tal, no confundirse con una persona de IR ADVISER.
  return POR_CLAVE.get(role) ?? role;
}

/** Roles que el panel deja asignar, de menos a más permisos. */
export const ASSIGNABLE_ROLES: readonly AssignableRole[] = ["ir_analyst", "ir_publisher", "ir_admin"];

/**
 * Estrecha el valor de un `<select>` sin `as`. Cualquier otro valor
 * -incluido un hipotético `client`- colapsa a analista, el rol con menos
 * permisos de los asignables.
 */
export function toAssignableRole(value: string): AssignableRole {
  return ASSIGNABLE_ROLES.find((role) => role === value) ?? "ir_analyst";
}

/** Administrador o Publicador: quien sube y administra insights (Req. 2). */
export function canManageStudies(role: string | null | undefined): boolean {
  return role === "ir_admin" || role === "ir_publisher";
}
